/**
 * @generated SignedSource<<ac72399f37b7aa7d259e2b5c275f562c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MeetingTitleAndXWCSwitcher_stream$data = {
  readonly account: {
    readonly id: string;
    readonly image: string;
    readonly name: string;
  };
  readonly isExternal: boolean;
  readonly relatedStreams: ReadonlyArray<{
    readonly account: {
      readonly id: string;
      readonly name: string;
    };
    readonly id: string;
    readonly isExternal: boolean;
    readonly " $fragmentSpreads": FragmentRefs<"MeetingTitleAndXWCSwitcherOption_stream">;
  }>;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingTitleAndXWCSwitcherOption_stream" | "MeetingTitleAndXWCSwitcher_ExternalStreamTooltip_stream">;
  readonly " $fragmentType": "MeetingTitleAndXWCSwitcher_stream";
};
export type MeetingTitleAndXWCSwitcher_stream$key = {
  readonly " $data"?: MeetingTitleAndXWCSwitcher_stream$data;
  readonly " $fragmentSpreads": FragmentRefs<"MeetingTitleAndXWCSwitcher_stream">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isExternal",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = {
  "args": null,
  "kind": "FragmentSpread",
  "name": "MeetingTitleAndXWCSwitcherOption_stream"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MeetingTitleAndXWCSwitcher_stream",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": "image",
          "args": null,
          "kind": "ScalarField",
          "name": "logo",
          "storageKey": null
        },
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MeetingTitleAndXWCSwitcher_ExternalStreamTooltip_stream"
    },
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "NoteStream",
      "kind": "LinkedField",
      "name": "relatedStreams",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "account",
          "plural": false,
          "selections": [
            (v1/*: any*/),
            (v2/*: any*/)
          ],
          "storageKey": null
        },
        (v3/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "NoteStream",
  "abstractKey": null
};
})();

(node as any).hash = "438192738387b776c5d83a01709b2650";

export default node;
